module.exports = __webpack_public_path__ + "img/happytablet_bg.8b498d85.jpg";